/**
 * Traditional Chinese (TWD + HKD) tag-focused transaction feed for the tags
 * use case.
 */

/** @type {Array<import('../../mock-tagged-transactions.js').MockTaggedTransaction>} */
export const MOCK_TAGGED_TRANSACTIONS_ZH_TW = [
	{
		id: 'tag-1',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 1540,
		description: '商務午餐',
		accountId: 'acc-credit',
		accountName: '港島返利卡',
		currency: 'HKD',
		currencySymbol: 'HK$',
		currencyDecimalPlaces: 2,
		tagNames: '業務, 稅務',
	},
	{
		id: 'tag-2',
		date: '2026-08-01',
		type: 'Deposit',
		amount: 76800,
		description: '薪水',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '收入',
	},
	{
		id: 'tag-3',
		date: '2026-07-29',
		type: 'Withdrawal',
		amount: 35200,
		description: '房租',
		accountId: 'acc-checking',
		accountName: '常綠銀行',
		currency: 'TWD',
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		tagNames: '帳單',
	},
	{
		id: 'tag-4',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 4000,
		description: '業務書籍',
		accountId: 'acc-credit',
		accountName: '港島返利卡',
		currency: 'HKD',
		currencySymbol: 'HK$',
		currencyDecimalPlaces: 2,
		tagNames: '業務, 稅務',
	},
	{
		id: 'tag-5',
		date: '2026-07-20',
		type: 'Purchase',
		amount: 7050,
		description: '軟體訂閱',
		accountId: 'acc-credit',
		accountName: '港島返利卡',
		currency: 'HKD',
		currencySymbol: 'HK$',
		currencyDecimalPlaces: 2,
		tagNames: '業務, 稅務',
	},
	{
		id: 'tag-6',
		date: '2026-07-18',
		type: 'Purchase',
		amount: 1025,
		description: '超市',
		accountId: 'acc-credit',
		accountName: '港島返利卡',
		currency: 'HKD',
		currencySymbol: 'HK$',
		currencyDecimalPlaces: 2,
		tagNames: '餐飲',
	},
];
